import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaStickyUtility from '@sparta.global.utilities/sparta-sticky-utility/dist/es6.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import sbCreditCardUtility from '@sparta.sb-credit-cards.utilities/sb-credit-card-utility/dist/es6.js';
import { link, layerContent } from '@sparta.global.helpers/sparta-helper/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <p>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerCardUnavailable") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\n  <p class=\"spa-btn-group\">\n    "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"unavailableContinue") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":23,"column":4},"end":{"line":23,"column":46}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"unavailableReturn") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":23,"column":47},"end":{"line":23,"column":87}}})) != null ? stack1 : "")
    + "\n  </p>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row\">\n  <div class=\"column small-12\">\n    <div class=\"error-message-home error hide\">\n      <p>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"ccErrorMsg") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\n      "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"boaHomeLink") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":5,"column":6},"end":{"line":5,"column":42}}})) != null ? stack1 : "")
    + "\n    </div>\n    <div class=\"error-message-generic error hide\">\n      <p>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"ccErrorMsg") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\n      "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"ccHomeLink") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":9,"column":6},"end":{"line":9,"column":41}}})) != null ? stack1 : "")
    + "\n    </div>\n  </div>\n</div>\n\n<div class=\"loading-overlay hide\">\n  <div class=\"loader active\"></div>\n</div>\n\n"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"interstitialPlaceHolder") : stack1), depth0)) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"layerCardUnavailable") : stack1),{"name":"layerContent","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":0},"end":{"line":25,"column":17}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.sb-credit-cards.modules/utility-cc-module",
  "version": "1.0.0",
  "id": "UtilityCcModule",
  "containerID": "sbCreditCardsUtilityCcModule",
  "moduleName": "sb-credit-cards-utility-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "utility-cc-module",
  "data": {
    "init": "UtilityCcModuleJS",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        link,
        layerContent
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    link,
    layerContent
  },
  "dependencies": {
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-sticky-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.sb-credit-cards.utilities/sb-credit-card-utility": "^1.0.0"
  },
  "stores": []
};

/**
 *Creates an instance of UtilityCcModule
 *
 * @export
 * @class UtilityCcModuleJS
 * @extends {Module}
 */
class UtilityCcModuleJS extends Module {
  /**
   * constructor
   *
   * @param {Object} options // Module options
   * @param {Object} context // Module context
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const target = this.settings.target;
    this.errorMessageHome = target.querySelector('.error-message-home');
    this.errorMessageGeneric = target.querySelector('.error-message-generic');
    this.loadingOverlay = target.querySelector('.loading-overlay');
  }

  /**
   * initializes UtilityCcModuleJS
   * @returns {void}
   */
  init() {
    this.subscribeEvents();
  }

  /**
   * subscribeEvents
   *
   * @todo errorShow ones may need to have a data.target to clone element into vs show and hide.
   * The cc overview/homepage is the only one that uses 2 cc lists modules as children of the
   * filter module and if either request fail, we display the error for both tabs. We assume
   * that both requests would fail in this case.
   */
  /**
   * @memberof UtilityCcModuleJS
   * @returns {void}
   */
  subscribeEvents() {
    this.Events.sub(sbCreditCardUtility.EVENTS.errorShowHome, () => {
      this.errorMessageHome.classList.remove('hide');
    });
    this.Events.sub(sbCreditCardUtility.EVENTS.errorShowGeneric, () => {
      this.errorMessageGeneric.classList.remove('hide');
    });
    this.Events.sub(sbCreditCardUtility.EVENTS.loaderShow, () => {
      this.loadingOverlay.classList.remove('hide');
    });
    this.Events.sub(sbCreditCardUtility.EVENTS.loaderHide, () => {
      this.loadingOverlay.classList.add('hide');
    });
    this.Events.sub(spartaUILayersUtility.EVENTS.MODAL_CLOSED, () => {
      // Needed for sticky to be in proper position. Covering global nav.
      // Fix for when scrolled down prior to ui layers opening.
      setTimeout(() => {
        spartaStickyUtility.recalcStickyEls();
      }, 250);
    });
  }
}
registerModuleClass({
  moduleClass: UtilityCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { UtilityCcModuleJS as default, moduleConfig };
